import { Select, SelectProps, OptionType } from './Select';
import { SelectWithIcon } from './SelectWithIcon';

export default Select;
export type { SelectProps, OptionType }
export { Select, SelectWithIcon }
